import Button from "@material-ui/core/Button";
import CreditOfferExpanded from "./CreditOfferExpanded";
import { OfferStyle } from "./helper";

const RenderOfferWithButtonCmp = ({
  offerWithDecision,
  index,
  applicationId,
  approveRejectCreditOffers,
}) => {
  return (
    <div key={"offermapping" + index} style={OfferStyle.Borderless}>
      <Button
        className="approveReject"
        variant="contained"
        color="primary"
        style={{ marginLeft: "2px", marginBottom: "16px" }}
        onClick={() =>
          approveRejectCreditOffers(
            applicationId,
            offerWithDecision.PayoutAmount,
          )
        }
      >
        {`Up to ${offerWithDecision.PayoutAmount}`}
      </Button>
      <CreditOfferExpanded {...{ offerWithDecision }} />
    </div>
  );
};

export default RenderOfferWithButtonCmp;
